import { render } from "./OpportunityList.vue?vue&type=template&id=ae59dbe2&scoped=true"
import script from "./OpportunityList.vue?vue&type=script&lang=js"
export * from "./OpportunityList.vue?vue&type=script&lang=js"

import "./OpportunityList.vue?vue&type=style&index=0&id=ae59dbe2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae59dbe2"

export default script